<!--CC: before connection — Exchange-->
<div class="flex-column f-1-0 align-items-center gap-4" style="padding-top: 60px;"
	 *ngIf="planInfo && !connected && integrationType === dic.CONSTANTS.integrationType.exchange">

	<div class="flex-column align-items-center gap-3 border border-2 rounded p-5 animated fadeIn" style="max-width: 460px;">
		<img src="images/integrationsLogos/exchange-logo.png" style="width: 56px; height: 56px; object-fit: contain;" />
		<span class="fw-bold" style="font-size: 1.1rem;">Connect to Microsoft Exchange</span>
		<span class="text-muted text-center lh-base" style="font-size: 0.9rem;">
			Allow Trustifi to establish a secure connection to your Exchange server to enable mailbox protection, contact sync, and additional security features.
		</span>
		<!--CC: taken from exchange-integration.component.html -> Cloud API endpoint-->
		<div class="flex-row align-items-center gap-3">
			<span class="fw-bold" style="font-size: 0.9rem;">Cloud API endpoint:</span>
			<app-dropdown-c style="width: 210px; --bs-dropdown-max-height: 180px; --bs-dropdown-overflow: auto; display: block;" [text]="selectedServerEndpoint.name">
				<li *ngFor="let entry of dic.CONSTANTS.exchangeServerEndpoints | keyvalue"
					(click)="changeEndpoint(entry.value)">
					{{ entry.value.name }}
				</li>
			</app-dropdown-c>
		</div>
		<p class="text-warning text-center" role="note" *ngIf="selectedServerEndpoint.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>
		<ng-container *ngTemplateOutlet="advancedPermissionsToggle"></ng-container>
		<btn-c style="margin-top: 8px;"
			   endIcon="far fa-plug"
			   [loading]="connectInProcess"
			   (action)="connectExchange();">
			Connect
		</btn-c>
	</div>
</div>

<!--CC: taken from exchange-integration.component.html -> Change endpoint popup-->
<popup-c class="bs-enabled" *ngIf="changeEndPointPopup?.show"
		 head="Change cloud API endpoint" size="dynamic"
		 (closeCb)="changeEndPointPopup.show = false;"
		 (confirmCb)="changeEndPointPopup.endpoint ? saveSovereignCloud() : changeEndPointPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Change', disabled: changeEndPointPopup.applyInProcess || connectInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			{{changeEndPointPopup.subTitle}}
		</div>

		<p class="text-warning" role="note" *ngIf="changeEndPointPopup.endpoint?.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>

		<ul>
			<li>Make sure you have selected the correct endpoint. Selecting an incorrect endpoint can cause communication failures with the cloud API.</li>
			<li *ngIf="changeEndPointPopup.endpoint">Create one app with all required permissions. Its client ID and secret are shared by Exchange, EXO Admin and Collaboration. Disconnect all three before changing the cloud or app. The tenant is detected during consent.</li>
		</ul>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.endpoint">
			<div style="min-width: 120px;">Client ID</div>
			<input type="text" placeholder="Client ID" style="width:330px;" [required]="true" [(ngModel)]="changeEndPointPopup.clientIdInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.endpoint">
			<div style="min-width: 120px;">Client secret</div>
			<input type="password" placeholder="Client secret" style="width:330px;" [required]="!changeEndPointPopup.clientSecretSet" [(ngModel)]="changeEndPointPopup.clientSecretInput"/>
		</div>
		<span *ngIf="changeEndPointPopup.endpoint && changeEndPointPopup.clientSecretSet" style="font-size: 12px;">Leave a secret blank only when keeping the same cloud and client ID.</span>

		<!--will show only when selecting exchangeServerEndpoints.Hybrid-->
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.azureADInput !== undefined">
			<div style="min-width: 120px;">Azure AD</div>
			<input type="text" placeholder="Azure AD endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.azureADInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.microsoftGraphAPIInput !== undefined">
			<div style="min-width: 120px;">Microsoft Graph API</div>
			<input type="text" placeholder="Microsoft Graph API endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.microsoftGraphAPIInput"/>
		</div>
	</div>
</popup-c>

<!--CC: before connection — GSuite-->
<div class="flex-column f-1-0 align-items-center gap-4" style="padding-top: 60px;"
	 *ngIf="planInfo && !connected && integrationType === dic.CONSTANTS.integrationType.gsuite">

	<div class="flex-column align-items-center gap-3 border border-2 rounded p-5 animated fadeIn" style="max-width: 460px;">
		<img src="images/integrationsLogos/gsuite-logo.png" style="width: 56px; height: 56px; object-fit: contain;" />
		<span class="fw-bold" style="font-size: 1.1rem;">Connect to Google Workspace</span>
		<span class="text-muted text-center lh-base" style="font-size: 0.9rem;">
			Allow Trustifi to establish a secure connection to your Google Workspace to enable mailbox protection, contact sync, and additional security features.
		</span>
		<btn-c style="margin-top: 8px;"
			   endIcon="far fa-plug"
			   (action)="showGsuiteConfigPopup();">
			Connect
		</btn-c>
	</div>
</div>

<!--CC: taken from gsuite-integration.component.html -> Configure Google Workspace popup, redesigned-->
<popup-c *ngIf="gsuiteConfigPopup?.show"
		 head="Configure Google Workspace" size="large"
		 (closeCb)="gsuiteConfigPopup = null;"
		 (confirmCb)="connectGsuite();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect', loading: connectInProcess}}">
	<div class="flex-column f-1-0 gap-4" style="overflow: auto; padding: 4px 0;">

		<!--CC: section 1 — API delegation setup-->
		<div class="flex-column gap-3 rounded p-3" style="background: var(--bs-light);">
			<span class="fw-bold" style="font-size: 0.95rem;">Set up Domain-Wide Delegation</span>

			<div class="flex-column gap-2" style="font-size: 0.9rem; line-height: 1.6;">
				<span>1. Log in to your <a class="blue-link fw-bold" href="https://admin.google.com/" target="_blank">Google Admin Console</a></span>
				<span>2. Navigate to <b>Security</b> <i class="far fa-chevron-right" style="font-size: 0.65rem; margin: 0 2px; opacity: 0.5;"></i> <b>API Controls</b></span>
				<span>3. Click <b>Manage Domain Wide Delegation</b> at the bottom of the page</span>
				<span>4. In the <b>API Clients</b> table, click <b>Add New</b></span>
				<span>5. Paste the following <b>Client ID</b>:</span>
			</div>

			<div class="flex-row align-items-center gap-2 rounded px-3 py-2 border" style="background: white;">
				<span class="f-1-0 text-truncate click-select-all" style="font-family: monospace; font-size: 0.9rem;">{{planInfo.googleAdminAppId}}</span>
				<a (click)="gs.copyToClipboard(planInfo.googleAdminAppId);" tooltip="Copy Client ID" class="cursor-pointer">
					<i class="far fa-copy copy-link"></i>
				</a>
			</div>

			<span style="font-size: 0.9rem;">6. Paste the following <b>OAuth scopes</b>:</span>

			<!--Issue #15842: the full scope list (basic + advanced) is the default-->
			<ng-container *ngTemplateOutlet="advancedPermissionsToggle"></ng-container>

			<div class="flex-row align-items-center gap-2 rounded px-3 py-2 border" style="background: white;">
				<span class="f-1-0 text-truncate click-select-all" style="font-family: monospace; font-size: 0.8rem;">{{advancedPermissions ? googleAdvancedScopesLine : googleScopesLine}}</span>
				<a (click)="gs.copyToClipboard(advancedPermissions ? googleAdvancedScopes : googleScopes);" tooltip="Copy OAuth scopes" class="cursor-pointer">
					<i class="far fa-copy copy-link"></i>
				</a>
			</div>

			<span style="font-size: 0.9rem;">7. Click <b>Authorize</b></span>
		</div>

		<!--CC: section 2 — Entity ID-->
		<div class="flex-column gap-3 rounded p-3" style="background: var(--bs-light);">
			<span class="fw-bold" style="font-size: 0.95rem;">Get your Entity ID</span>

			<div class="flex-column gap-2" style="font-size: 0.9rem; line-height: 1.6;">
				<span>1. Go to your <a class="blue-link fw-bold" href="https://admin.google.com/" target="_blank">Google Admin Console</a> home page</span>
				<span>2. Navigate to <b>Security</b> <i class="far fa-chevron-right" style="font-size: 0.65rem; margin: 0 2px; opacity: 0.5;"></i> <b>Set up single sign-on (SSO) for SAML applications</b></span>
				<span>3. Copy the last part of the <b>Entity ID</b> URL:</span>
			</div>

			<div class="flex-row align-items-center gap-2 rounded px-3 py-2 border" style="background: white; font-size: 0.85rem;">
				<span style="font-family: monospace; opacity: 0.5;">https://accounts.google.com/o/saml2?idpid=</span>
				<span style="font-family: monospace; color: #ec407a; font-weight: 600;">XXXXXXXXX</span>
				<span class="text-muted" style="font-size: 0.75rem;">⬅ your Entity ID</span>
			</div>
		</div>

		<!--CC: guide link-->
		<a class="blue-link flex-row align-items-center gap-1 justify-content-end" style="font-size: 0.85rem;"
		   target="_blank" rel="noopener noreferrer" href="https://docs.trustifi.com/docs/google-workspaces">
			<i class="far fa-book" style="font-size: 0.75rem;"></i>
			<span>Full guide with screenshots</span>
			<i class="far fa-external-link" style="font-size: 0.7rem;"></i>
		</a>

	</div>

	<!--CC: section 3 — credentials input, outside scrollable area so always visible-->
	<div class="flex-column gap-3" style="border-top: 1px solid var(--bs-border-color); padding-top: 16px;">
		<span style="font-size: 0.9rem;">Enter your email and the Entity ID you copied above, then click <b>Connect</b></span>
		<div class="flex-row align-items-center gap-3">
			<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Admin Email:</span>
			<input class="f-1-0" type="text"
				   [ngClass]="{'validation-error' : gsuiteForm.inputErrors.emailInput}"
				   [(ngModel)]="gsuiteForm.adminEmail"
				   (ngModelChange)="gsuiteForm.inputErrors.emailInput = false;" />
		</div>
		<div class="flex-row align-items-center gap-3">
			<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Entity ID:</span>
			<input class="f-1-0" type="text"
				   [ngClass]="{'validation-error' : gsuiteForm.inputErrors.idInput}"
				   [(ngModel)]="gsuiteForm.customerId"
				   (ngModelChange)="gsuiteForm.inputErrors.idInput = false;" />
		</div>
	</div>
</popup-c>

<!--CC: before connection — LDAP-->
<div class="flex-column f-1-0 align-items-center gap-4" style="padding-top: 20px;"
	 *ngIf="planInfo && !connected && integrationType === dic.CONSTANTS.integrationType.ldap">

	<div class="flex-column align-items-center gap-2 border border-2 rounded px-5 py-3 animated fadeIn" style="max-width: 500px;">
		<i class="far fa-server" style="font-size: 40px; color: var(--bs-secondary);"></i>
		<span class="fw-bold" style="font-size: 1.1rem;">Connect to LDAP</span>
		<span class="text-muted text-center lh-base" style="font-size: 0.9rem;">
			Allow Trustifi to establish a secure connection to your LDAP server to sync users and groups.
		</span>

		<!--CC: taken from ldap-integration.component.html -> LDAP connect form-->
		<div class="flex-column gap-2 w-100">
			<div class="flex-row align-items-center gap-3">
				<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Username:</span>
				<input class="f-1-0" type="text" [(ngModel)]="ldapForm.username" />
			</div>
			<div class="flex-row align-items-center gap-3">
				<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Password:</span>
				<input class="f-1-0" [type]="ldapForm.showPassword ? 'text' : 'password'"
					   [(ngModel)]="ldapForm.password" />
				<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;">
					<input type="checkbox" [(ngModel)]="ldapForm.showPassword"/>
					<i class="fas fa-eye unchecked"></i>
					<i class="fas fa-eye-slash checked"></i>
				</label>
			</div>
			<div class="flex-row align-items-center gap-3">
				<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Base DN:</span>
				<input class="f-1-0" type="text" [(ngModel)]="ldapForm.baseDN" />
			</div>
			<div class="flex-row align-items-center gap-3">
				<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Host:</span>
				<input class="f-1-0" type="text" [(ngModel)]="ldapForm.endpoint" />
			</div>
			<div class="flex-row align-items-center gap-3">
				<span class="fw-bold" style="min-width: 90px; font-size: 0.9rem;">Port:</span>
				<input class="f-1-0" type="number" [(ngModel)]="ldapForm.port" />
			</div>
			<div class="flex-row align-items-center gap-2">
				<input type="checkbox" [(ngModel)]="ldapForm.secure" style="width: 16px; height: 16px;" />
				<span style="font-size: 0.9rem;">Allow secure connection only</span>
			</div>
		</div>

		<!--CC: taken from ldap-integration.component.html -> IP allowlist notice-->
		<div class="flex-column w-100" style="font-size: 0.85rem;">
			<span>*Allowlist the following IPs in your firewall policy:</span>
			<span style="color: #d63384;">3.221.25.19, 35.172.145.174, 44.209.231.3, 34.192.117.166</span>
		</div>

		<btn-c style="margin-top: 4px;"
			   endIcon="far fa-plug"
			   [loading]="connectInProcess"
			   [isDisabled]="!ldapForm.username || !ldapForm.password || !ldapForm.endpoint"
			   (action)="connectLdap();">
			Connect
		</btn-c>
	</div>
</div>

<!--CC: after connection-->
<div class="flex-column f-1-0 gap-4 animated fadeIn" *ngIf="planInfo && connected">

	<!--CC: success banner-->
	<div class="flex-row align-items-center gap-3 p-3 rounded" style="background: rgba(25, 135, 84, 0.08);">
		<i class="far fa-check-circle text-success" style="font-size: 1.5rem;"></i>
		<div class="flex-column gap-1">
			<span class="fw-bold text-success">Connected to {{integrationType}}</span>
			<span class="text-muted" style="font-size: 0.85rem;">Your mail server is now integrated with {{gs.corpname}}</span>
		</div>
	</div>

	<!--CC: verified domains list (Exchange / GSuite)-->
	<ng-container *ngIf="integrationType !== dic.CONSTANTS.integrationType.ldap">
		<div class="flex-column gap-3" *ngIf="verifiedDomains?.length">
			<span class="fw-bold">Domains managed by your {{integrationType}} server</span>
			<div class="flex-column gap-2">
				<div class="flex-row align-items-center gap-2 px-3 py-2 border rounded" *ngFor="let domain of verifiedDomains">
					<i class="far fa-globe text-primary" style="font-size: 0.9rem;"></i>
					<span>{{domain}}</span>
				</div>
			</div>
		</div>

		<div class="flex-row align-items-center gap-2 text-muted" *ngIf="!verifiedDomains?.length">
			<i class="far fa-info-circle"></i>
			<span style="font-size: 0.9rem;">No verified domains found on your {{integrationType}} server.</span>
		</div>
	</ng-container>

	<!--CC: LDAP connection details-->
	<div class="flex-column gap-3" *ngIf="integrationType === dic.CONSTANTS.integrationType.ldap && planInfo.integrations.ldap">
		<span class="fw-bold">Connection details</span>
		<div class="flex-column gap-2">
			<div class="flex-row align-items-center gap-2 px-3 py-2 border rounded">
				<span class="text-muted" style="font-size: 0.85rem; min-width: 80px;">Username:</span>
				<span>{{planInfo.integrations.ldap.username}}</span>
			</div>
			<div class="flex-row align-items-center gap-2 px-3 py-2 border rounded">
				<span class="text-muted" style="font-size: 0.85rem; min-width: 80px;">Endpoint:</span>
				<span>{{planInfo.integrations.ldap.endpoint}}</span>
			</div>
			<div class="flex-row align-items-center gap-2 px-3 py-2 border rounded" *ngIf="planInfo.integrations.ldap.baseDN">
				<span class="text-muted" style="font-size: 0.85rem; min-width: 80px;">Base DN:</span>
				<span>{{planInfo.integrations.ldap.baseDN}}</span>
			</div>
		</div>
	</div>

	<!--CC: taken from exchange-integration.component.html -> Advanced Permissions (Exchange only)-->
	<div class="flex-column gap-3 border rounded p-3" *ngIf="integrationType === dic.CONSTANTS.integrationType.exchange">
		<div class="flex-row align-items-center justify-content-between">
			<div class="flex-column gap-1">
				<span class="fw-bold">Advanced Permissions</span>
				<span class="text-muted" style="font-size: 0.85rem;">{{advancedPermissionsInfo}}</span>
			</div>
			<div class="flex-row align-items-center gap-2">
				<span class="text-success fw-bold" style="font-size: 0.85rem;" *ngIf="advancedEnabled">Granted</span>
				<btn-c [loading]="advancedInProcess"
					   [endIcon]="advancedEnabled ? 'far fa-redo' : 'far fa-shield-check'"
					   (action)="connectExchangeAdvanced();">
					{{advancedEnabled ? 'Update Permissions' : 'Grant Advanced Permissions'}}
				</btn-c>
			</div>
		</div>
	</div>

	<!--Issue #15842: Advanced Permissions (GSuite) - the scopes actually authorized are compared with the advanced scope-->
	<div class="flex-column gap-3 border rounded p-3" *ngIf="integrationType === dic.CONSTANTS.integrationType.gsuite">
		<div class="flex-row align-items-center justify-content-between">
			<div class="flex-column gap-1">
				<span class="fw-bold">Advanced Permissions</span>
				<span class="text-muted" style="font-size: 0.85rem;">{{advancedPermissionsInfo}}</span>
			</div>
			<div class="flex-row align-items-center gap-2">
				<span class="text-success fw-bold" style="font-size: 0.85rem;" *ngIf="advancedEnabled">Authorized</span>
				<btn-c *ngIf="!advancedEnabled"
					   [loading]="advancedInProcess"
					   endIcon="far fa-shield-check"
					   (action)="verifyGsuiteAdvanced();">
					Verify
				</btn-c>
			</div>
		</div>
		<div class="flex-column gap-2" *ngIf="!advancedEnabled">
			<span class="text-warning" style="font-size: 0.85rem;">Not authorized. Add this scope to the {{gs.corpname}} client in Google Admin <i class="far fa-chevron-right" style="font-size: 0.65rem; margin: 0 2px; opacity: 0.5;"></i> Security <i class="far fa-chevron-right" style="font-size: 0.65rem; margin: 0 2px; opacity: 0.5;"></i> API Controls <i class="far fa-chevron-right" style="font-size: 0.65rem; margin: 0 2px; opacity: 0.5;"></i> Domain-Wide Delegation, then click Verify:</span>
			<div class="flex-row align-items-center gap-2 rounded px-3 py-2 border">
				<span class="f-1-0 text-truncate click-select-all" style="font-family: monospace; font-size: 0.85rem;">{{googleScopeActivity}}</span>
				<a (click)="gs.copyToClipboard(googleScopeActivity);" tooltip="Copy scope" class="cursor-pointer">
					<i class="far fa-copy copy-link"></i>
				</a>
			</div>
		</div>
	</div>

</div>

<!--Issue #15842: shared by the Exchange connect card and the Google Workspace popup-->
<ng-template #advancedPermissionsToggle>
	<div class="flex-column gap-2 border rounded p-3 w-100" style="background: white;">
		<div class="flex-row align-items-center gap-3">
			<toggle-switch-c [(model)]="advancedPermissions" [hideText]="true"></toggle-switch-c>
			<div class="flex-column gap-1">
				<span class="fw-bold" style="font-size: 0.9rem;">Advanced Permissions <span class="text-success fw-normal">(recommended)</span></span>
				<span class="text-muted" style="font-size: 0.85rem;">{{advancedPermissionsInfo}}</span>
			</div>
		</div>
		<span class="text-warning" style="font-size: 0.85rem;" *ngIf="!advancedPermissions">Basic permissions only: Account Takeover Protection will not be able to stop a takeover at sign-in.</span>
	</div>
</ng-template>

<!--CC: loading state-->
<div class="flex-column align-items-center justify-content-center f-1-0" *ngIf="!planInfo">
	<loader></loader>
</div>
